module.exports = __webpack_public_path__ + "img/client/f0c39d79f19dfd98d9768b1be2d46514.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/about-photo.png
// module id = ./src/pages/Home/about-photo.png
// module chunks = 6